import React from 'react';
import { View, Image } from 'react-native';
import { connect } from 'react-redux';
import {
  Button,
  ButtonTypes,
  Theme,
  LeaderboardUserBreakdown,
} from 'fitbeat.react-native-components';
import { GridLayoutWithRightContent } from './Layouts/GridLayoutWithRightContent';
import { createUserServiceClient } from 'fitbeat.react-native-components/utils/apiClientFactory';
import {
  loadUserBreakdownForLeaderboard as loadUserBreakdownForLeaderboardAction,
} from 'fitbeat.react-native-components/Tracking/actions';

const LeaderboardUserBreakdownContainer = (props) => (
  <GridLayoutWithRightContent {...props}>
    <View className='full-height' style={{ display: 'flex', flex: 1 }}>
      <View style={{ width: '20%', marginBottom: 5, marginTop: 5, flexDirection: 'row' }}>
        <Image
          style={{ resizeMode: 'contain', width: 15, height: 15 }}
          source={require('../../assets/keyboard-left-arrow-button.png')}
        />
        <Button
          onPress={() => props.navigation.navigate('TrackingDashboard')}
          isLoading={false}
          fontColor={Theme.PRIMARY}
          buttonType={ButtonTypes.OUTLINE}
          containerStyle={{ border: 'none', marginTop: -13, marginLeft: 5 }}
          title='Back'
        />
      </View>
      <LeaderboardUserBreakdown
        {...props}
      />
    </View>
  </GridLayoutWithRightContent>
);

const mapStateToProps = (state) => ({
  userBreakdown: state.tracking.data.userBreakdown,
  isLoadingUserBreakdown: state.tracking.view.isLoadingUserBreakdown,
  selectedTeam: state.summaryDashboard.data.selectedTeam,
});

const mapDispatchToProps = (dispatch, props) => {
  const userServiceClient = createUserServiceClient();
  const team = props.selectedTeam ?? props.navigation.state.params.team;

  return {
    loadUserBreakdownForLeaderboard: (
      userProfileId,
      leaderboardConfigId,
      startDate,
      endDate,
    ) => dispatch(
      loadUserBreakdownForLeaderboardAction(
        userServiceClient,
        userProfileId,
        leaderboardConfigId,
        startDate,
        endDate,
        team,
      ),
    ),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(LeaderboardUserBreakdownContainer);
